module.exports = __webpack_public_path__ + "static/media/spinner.f16c7534.gif";